module.exports = "/static/assets/04e10c82d2a75d397ca963c1a9f9e1e7.svg";